import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Key_getInstance3kkpczi3zr320 as Key_getInstance } from './CustomScalarAdapters.mjs';
import { MapJsonWriter4jz7ym6vbwk4 as MapJsonWriter } from './json/MapJsonWriter.mjs';
import { FileUploadAwareJsonWriter1mx337tg0y9oj as FileUploadAwareJsonWriter } from './json/internal/FileUploadAwareJsonWriter.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KtMap140uvy3s5zad8 as KtMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf1xd03cq9cnmy8 as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { Buffer3384y49aj0pxr as Buffer } from '../../../../../okio-parent-okio/okio/Buffer.mjs';
import { BufferedSinkJsonWriter1xl4ankftitqq as BufferedSinkJsonWriter } from './json/BufferedSinkJsonWriter.mjs';
import { writeAny16i13331zbqlc as writeAny } from './json/JsonWriters.mjs';
import { UploadsHttpBody13sq2iwgyese9 as UploadsHttpBody } from './http/DefaultHttpRequestComposer.mjs';
import { fromInt2ii0rejb1w62w as fromInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function toMap(_this__u8e3s4) {
  // Inline function 'kotlin.check' call
  if (!_this__u8e3s4.g4a_1.n1()) {
    var message = 'Apollo: sending uploads in this context is an error. Uploads are not supported by default for GET requests or subscriptions.';
    throw IllegalStateException().o(toString(message));
  }
  return toMapUnsafe(_this__u8e3s4);
}
var RequestParametersClass;
function RequestParameters() {
  if (RequestParametersClass === VOID) {
    class $ {
      constructor(query, operationName, variables, extensions, uploads, onError) {
        this.c4a_1 = query;
        this.d4a_1 = operationName;
        this.e4a_1 = variables;
        this.f4a_1 = extensions;
        this.g4a_1 = uploads;
        this.h4a_1 = onError;
      }
    }
    initMetadataForClass($, 'RequestParameters');
    RequestParametersClass = $;
  }
  return RequestParametersClass;
}
function toRequestParameters(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4.x43_1;
  var sendApqExtensions = tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  var sendEnhancedClientAwarenessExtensions = _this__u8e3s4.f44_1;
  var tmp1_elvis_lhs = _this__u8e3s4.y43_1;
  var sendDocument = tmp1_elvis_lhs == null ? true : tmp1_elvis_lhs;
  var tmp2_elvis_lhs = _this__u8e3s4.t43_1.p48(Key_getInstance());
  var scalarAdapters = tmp2_elvis_lhs == null ? Key_getInstance().d48_1 : tmp2_elvis_lhs;
  var jsonWriter = new (MapJsonWriter())();
  var uploadAwareWriter = new (FileUploadAwareJsonWriter())(jsonWriter);
  // Inline function 'com.apollographql.apollo.api.json.writeObject' call
  uploadAwareWriter.c41();
  _this__u8e3s4.p43_1.m49(uploadAwareWriter, scalarAdapters, false);
  uploadAwareWriter.d41();
  var tmp = jsonWriter.i41();
  var variables = (!(tmp == null) ? isInterface(tmp, KtMap()) : false) ? tmp : THROW_CCE();
  // Inline function 'kotlin.collections.mutableMapOf' call
  var ext = LinkedHashMap().fc();
  if (sendApqExtensions) {
    ext.b5('persistedQuery', mapOf([to('version', 1), to('sha256Hash', _this__u8e3s4.p43_1.operationId())]));
  }
  if (sendEnhancedClientAwarenessExtensions) {
    ext.b5('clientLibrary', mapOf([to('name', 'apollo-kotlin'), to('version', '5.2.0')]));
  }
  if (!(_this__u8e3s4.r43_1 == null)) {
    ext.d5(_this__u8e3s4.r43_1);
  }
  var tmp_0 = sendDocument ? _this__u8e3s4.p43_1.i4a() : null;
  var tmp_1 = _this__u8e3s4.p43_1.operationName();
  // Inline function 'kotlin.collections.mapKeys' call
  var this_0 = uploadAwareWriter.l4a();
  // Inline function 'kotlin.collections.mapKeysTo' call
  var destination = LinkedHashMap().gc(mapCapacity(this_0.q2()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s = this_0.l3().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp_2 = 'variables.' + element.m3();
    var tmp$ret$7 = element.n3();
    destination.b5(tmp_2, tmp$ret$7);
  }
  return new (RequestParameters())(tmp_0, tmp_1, variables, ext, destination, _this__u8e3s4.s43_1);
}
function toHttpBody(_this__u8e3s4) {
  // Inline function 'com.apollographql.apollo.api.json.buildJsonByteString' call
  var buffer = new (Buffer())();
  var $this$buildJsonByteString = new (BufferedSinkJsonWriter())(buffer, null);
  writeAny($this$buildJsonByteString, toMapUnsafe(_this__u8e3s4));
  var byteString = buffer.d3z();
  var tmp;
  if (_this__u8e3s4.g4a_1.n1()) {
    tmp = new (toHttpBody$1())(byteString);
  } else {
    tmp = new (UploadsHttpBody())(_this__u8e3s4.g4a_1, byteString);
  }
  return tmp;
}
function toMapUnsafe(_this__u8e3s4) {
  // Inline function 'kotlin.collections.buildMap' call
  // Inline function 'kotlin.collections.buildMapInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = LinkedHashMap().fc();
  if (!(_this__u8e3s4.c4a_1 == null)) {
    this_0.b5('query', _this__u8e3s4.c4a_1);
  }
  this_0.b5('operationName', _this__u8e3s4.d4a_1);
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!_this__u8e3s4.e4a_1.n1()) {
    this_0.b5('variables', _this__u8e3s4.e4a_1);
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!_this__u8e3s4.f4a_1.n1()) {
    this_0.b5('extensions', _this__u8e3s4.f4a_1);
  }
  if (!(_this__u8e3s4.h4a_1 == null)) {
    this_0.b5('onError', _this__u8e3s4.h4a_1.toString());
  }
  return this_0.g8();
}
var toHttpBody$1Class;
function toHttpBody$1() {
  if (toHttpBody$1Class === VOID) {
    class $ {
      constructor($byteString) {
        this.o4a_1 = $byteString;
        this.m4a_1 = 'application/json';
        this.n4a_1 = fromInt($byteString.q2());
      }
      p4a() {
        return this.m4a_1;
      }
      q4a() {
        return this.n4a_1;
      }
      r4a(bufferedSink) {
        bufferedSink.p3z(this.o4a_1);
      }
    }
    initMetadataForClass($);
    toHttpBody$1Class = $;
  }
  return toHttpBody$1Class;
}
//region block: exports
export {
  toHttpBody as toHttpBody2x6lfaxkoi6pf,
  toMap as toMap14rbdrx2whbk6,
  toRequestParameters as toRequestParameters3ovu7e0943da8,
};
//endregion

//# sourceMappingURL=RequestParameters.mjs.map
